// Updated map color scheme — muted grey tones with subdued water and no POIs/transit/highways

export const STUDENT_NETWORK_MAP_STYLE: google.maps.MapTypeStyle[] = [
    {
        featureType: 'administrative',
        elementType: 'geometry',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#9ca8b9' }],
    },
    {
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9ca8b9' }],
    },
    {
        featureType: 'administrative.country',
        elementType: 'geometry',
        stylers: [{ visibility: 'on' }],
    },
    {
        featureType: 'administrative.land_parcel',
        elementType: 'geometry',
        stylers: [{ visibility: 'on' }],
    },
    {
        featureType: 'administrative.locality',
        elementType: 'geometry',
        stylers: [{ visibility: 'on' }],
    },
    {
        featureType: 'administrative.neighborhood',
        elementType: 'geometry',
        stylers: [{ visibility: 'on' }],
    },
    {
        featureType: 'administrative.province',
        elementType: 'geometry',
        stylers: [{ visibility: 'on' }],
    },
    {
        featureType: 'landscape',
        stylers: [{ color: '#f7f7fa' }],
    },
    {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'road',
        stylers: [{ saturation: -30 }, { lightness: 10 }],
    },
    {
        featureType: 'road.arterial',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'road.highway',
        stylers: [{ saturation: -26 }, { visibility: 'off' }],
    },
    {
        featureType: 'transit',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [{ color: '#d9dbde' }],
    },
    {
        featureType: 'water',
        elementType: 'labels',
        stylers: [{ color: '#847d76' }, { saturation: -100 }, { lightness: -5 }],
    },
    {
        featureType: 'water',
        elementType: 'labels.text',
        stylers: [{ color: '#5d6a7c' }],
    },
];
